import type { ReactNode } from 'react';

export interface MinigameSlotProps {
  /** Minigame identifier */
  minigameId: string;
  /** Parameters passed to the minigame */
  params?: Record<string, unknown>;
  /** Called when the minigame completes */
  onComplete?: (result?: unknown) => void;
  /** Child components to render (the actual minigame) */
  children?: ReactNode;
}

export function MinigameSlot({
  minigameId,
  params,
  onComplete,
  children,
}: MinigameSlotProps) {
  // If no children provided, render a placeholder
  if (!children) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'rgba(0, 0, 0, 0.9)',
          zIndex: 800,
        }}
        data-minigame-id={minigameId}
        data-minigame-params={JSON.stringify(params)}
      >
        <div
          style={{
            padding: '24px 48px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '8px',
            color: 'white',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '1.25rem', marginBottom: '8px' }}>
            Minigame: {minigameId}
          </div>
          <button
            onClick={() => onComplete?.()}
            style={{
              padding: '8px 24px',
              background: '#4a90d9',
              border: 'none',
              borderRadius: '4px',
              color: 'white',
              cursor: 'pointer',
              fontSize: '1rem',
            }}
          >
            Skip
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 800,
      }}
      data-minigame-id={minigameId}
    >
      {children}
    </div>
  );
}
